<template>
    <div>
      <div class="container">
            <div class="handle-box">
              <el-select v-model="apply_query.status" clearable placeholder="状态" style="width: 150px;margin-right: 4px;">
                <el-option v-for="itm in applyStatusOptions" :key="itm.value" :label="itm.label"
                  :value="Number(itm.value)"></el-option>
              </el-select>
              <el-input v-model="apply_query.order_no" style="width:180px;" placeholder="订单编号"></el-input>
              <el-input v-model="apply_query.transaction_id" style="width:180px;" placeholder="收款编号"></el-input>
              <el-select v-model="apply_query.type" clearable placeholder="收款方式" style="width: 200px;margin-right: 4px;">
                <el-option v-for="itm in PAY_TYPE" :key="itm.value" :label="itm.label"
                  :value="Number(itm.value)"></el-option>
              </el-select>
              <el-input v-model="apply_query.no" style="width:180px;" placeholder="退款编号"></el-input>
              <el-input v-model="apply_query.real_name" style="width:100px;" placeholder="客户称呼"></el-input>
              <el-input v-model="apply_query.nickname" style="width:100px;" placeholder="昵称"></el-input>
              <el-input v-model="apply_query.phone" style="width:130px;" placeholder="客户手机号"></el-input>
              <el-date-picker v-model="value2" type="datetimerange" value-format="YYYY-MM-DD HH:mm:ss"
                format="YYYY-MM-DD HH:mm:ss" align="right" start-placeholder="开始日期" end-placeholder="结束日期"
                :default-time="['0000-00-00 00:00:00', '3000-00-00 23:59:59']" style="margin-right: 10px;">
              </el-date-picker>
              <el-button type="primary" class="export-excel-wrapper" icon="el-icon-search"
                @click="handleApplySearch">搜索</el-button>
              <vue3-json-excel class="export-excel-wrapper" :json-data="json_refund_data" :fields="json_refund_fields"
                :before-generate="handleRefundDownload" name="退款.xls">
                <el-button icon="el-icon-download">导出</el-button>
              </vue3-json-excel>
              <el-tooltip class="item" effect="dark" content="退款导出时必须选择时间段，并且一次性最多只能导出3个月的内容" placement="top-start">
                <el-button class="el-button-problem" icon="el-icon-warning-outline" type="text"></el-button>
              </el-tooltip>
            </div>
            <el-table :data="refundApplyData" border class="table" ref="multipleTable"
              header-cell-class-name="table-header">
              <el-table-column type="expand">
                <template #default="scope">
                  备注：{{ scope.row.memo }}
                </template>
              </el-table-column>
              <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
  
              <el-table-column label="订单编号" width="130">
                <template #default="scope">
                  <el-button type="text" :style="'color:#409EFF'" @click="showDetail(scope.row.order_id)">
                    {{ scope.row.order_no }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column prop="transaction_id" label="收款编号" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="nickname" label="客户">
                <template #default="scope">
                  {{ scope.row.real_name || scope.row.nickname }}
                </template>
              </el-table-column>
              <el-table-column prop="phone" label="客户手机号" width="110"></el-table-column>
              <el-table-column prop="apply_name" label="申请人"></el-table-column>
              <el-table-column prop="no" label="退款编号" width="170" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="money" label="退款金额" align="right">
                <template #default="scope">{{ (scope.row.money / 100).toFixed(2) }}</template>
              </el-table-column>
              <el-table-column prop="status" label="退款状态">
                <template #default="scope">
                  <span>{{ applyStatusMap.get(scope.row.status) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="pay_type_name" label="收款方式">
                <template #default="scope">{{ typeMap.get(scope.row.type) }}</template>
              </el-table-column>
              <el-table-column prop="c_at" :formatter="dateFormatHMS" label="申请时间" width="170">
              </el-table-column>
              <el-table-column prop="u_at" :formatter="dateFormatHMS" label="退款时间" width="170">
              </el-table-column>
              <el-table-column label="操作" width="200" align="center">
                <template #default="scope">
                  <el-popconfirm v-if="scope.row.status === 2" confirm-button-text="是" cancel-button-text="否"
                    :icon="InfoFilled" icon-color="#626AEF" title="确定退款?" @confirm="handleRefund(scope.row.id, 1)">
                    <template #reference>
                      <el-button type="text" class="warning">退款
                      </el-button>
                    </template>
                  </el-popconfirm>
                  <el-popconfirm v-if="scope.row.status === 2" confirm-button-text="是" cancel-button-text="否"
                    :icon="InfoFilled" icon-color="#626AEF" title="确定不退款?" @confirm="handleRefund(scope.row.id, 0)">
                    <template #reference>
                      <el-button type="text" class="warning">拒绝退款
                      </el-button>
                    </template>
                  </el-popconfirm>
                  <el-button type="text" class="warning" v-if="scope.row.status === 2"
                    @click="setRefundMoney(scope.row)">修改金额
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination">
              <el-pagination @size-change="handleApplyizeChange" @current-change="handleApplyPageChange"
                :current-page="apply_query.page" :page-sizes="[10, 20, 30, 40, 50, 100, 200]" :page-size="10"
                layout="total,sizes, prev, pager, next" :total="applyPageTotal">
              </el-pagination>
            </div>
      </div>
      <el-dialog title="修改金额" v-model="moenyVisible" width="30%" :before-close="handleMoenyClose">
        <el-form>
          <el-form-item>
            <span style="margin-left: 5px;color: gray;">剩余可退金额<span style="color:red;">{{ surpluseMoney }}元</span></span>
          </el-form-item>
          <el-form-item>
            <el-input-number v-model="moneyForm.amount" placeholder="输入修改后的金额" :precision="2" :min="0" :controls="false"
              :max="4294967295" /><el-button type="primary" style="margin-left: 10px;" @click="editMoney">确认修改</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog title="订单详情" v-model="detailVisible" width="40%" :before-close="handleClose">
      <div class="list_box">
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">订单编号</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.no }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">用户昵称</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.nickname }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">手机号</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.phone }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">门店</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.store_name }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">订单类型</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.type_name }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">订单状态</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.status_name }}</div>
          </el-col>
        </el-row>
      </div>
      <div v-if="theDetail.time_order_list != null && theDetail.time_order_list.length > 0">
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">开始时间</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ ForMatHMS(theDetail.time_order_list.start_time) }} </div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">结束时间</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ ForMatHMS(theDetail.time_order_list.end_time) }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">加时时长</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{
              ((theDetail.time_order_list.end_time - theDetail.time_order_list.start_time) / 3600).toFixed(1) }}小时</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">加时价格</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ (theDetail.time_order_list.price / 100).toFixed(2) }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">加时订单</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.time_order_list.no }}</div>
          </el-col>
        </el-row>
      </div>

      <div v-if="theDetail.order_room !== null">
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">开始时间</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ ForMatHMS(theDetail.order_room.start_time) }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">结束时间</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ ForMatHMS(theDetail.order_room.end_time) }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">房间时长</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ (theDetail.order_room.end_time -
              theDetail.order_room.start_time) / 3600 }}小时</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">房间价格</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ (theDetail.order_room.price / (100)).toFixed(2) }}</div>
          </el-col>
        </el-row>
      </div>

      <div v-if="theDetail.order_meal !== null">
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">套餐</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.order_meal.meal_name }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">时长</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.order_meal.hour }}小时</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">价格</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ (theDetail.order_meal.price / 100).toFixed(2) }}</div>
          </el-col>
        </el-row>
      </div>

      <div v-if="theDetail.product_list.length > 0">
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">商品名称</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.product_list[0].product_name }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">规格名称</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.product_list[0].specs_name }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">数量</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.product_list[0].num }}</div>
          </el-col>
        </el-row>
      </div>

      <div v-if="theDetail.order_address != null">
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">收货人</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.order_address.consignee }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">联系方式</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.order_address.mobile }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">省市区</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">
              {{ theDetail.order_address.province + theDetail.order_address.city + theDetail.order_address.area }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">详细地址</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.order_address.content }}</div>
          </el-col>
        </el-row>
      </div>

      <div v-if="theDetail.order_address != null">
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">收货人</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.order_address.consignee }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">联系方式</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.order_address.mobile }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">省市区</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">
              {{ theDetail.order_address.province + theDetail.order_address.city + theDetail.order_address.area }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">详细地址</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.order_address.content }}</div>
          </el-col>
        </el-row>
      </div>
      <div v-if="theDetail.type === 5">
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">充值金额</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ (theDetail.order_balance.charge / 100).toFixed(2) }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">赠送金额</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">
              {{ ((theDetail.order_balance.deposit - theDetail.order_balance.charge) / 100).toFixed(2) }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">到账金额</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ (theDetail.order_balance.deposit / 100).toFixed(2) }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">通用类型</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ (theDetail.store_id == 0 ? "平台通用" : theDetail.store_name) }}</div>
          </el-col>
        </el-row>
      </div>
      <el-row :gutter="16">
        <el-col :span="6">
          <div class="grid-content bg-purple">备注</div>
        </el-col>
        <el-col :span="10">
          <div class="grid-content bg-purple">{{ theDetail.memo }}</div>
        </el-col>
      </el-row>
    </el-dialog>
    </div>
  </template>
  
  <script>
  import {
    get_refund_list,
    handleRefund,
    getRefundApplyStatusName,
    getDetail,
    editRefundMoney
  } from "@/api/finance";
  import moment from "moment";
  import { getAreaOption, getStoreOption } from "@/api/store";
  import { ORDER_TYPE } from "@/constant/order";
  import { PAY_TYPE } from "@/constant/pay";
  import { Refund_TYPE, Refund_Status } from "@/constant/refundType";
  import { ElMessage, ElTableColumn } from "element-plus";
  import { status } from "@/constant/status";
  export default {
    name: "financetable",
    components: { ElTableColumn},
    computed: {
      ORDER_TYPE() {
        return ORDER_TYPE
      },
      PAY_TYPE() {
        return PAY_TYPE
      },
      Refund_TYPE() {
        return Refund_TYPE
      },
      status() {
        return status
      },
      Refund_Status() {
        return Refund_Status
      }
    },
    data() {
      return {
        detailVisible: false,
        query: {
          store_id: null,
          order_no: "",
          real_name: "",
          nickname: '',
          phone: "",
          add_start: null,
          add_end: null,
          add_start_utc: null,
          add_end_utc: null,
          page: 1,
          page_size: 10,
          type: '',
          order_type: '',
          order_title: ''
        },
        apply_query: {
          status: null,
          order_no: "",
          transaction_id: "",
          no: "",
          nickname: "",
          phone: "",
          add_start: null,
          add_end: null,
          add_start_utc: null,
          add_end_utc: null,
          page: 1,
          page_size: 10
        },
        typeList: [],
        payType: [],
        storeOptions: [], // 门店信息
        applyStatusOptions: [], // 退款申请状态
        applyStatusMap: new Map(),
        tableData: [],
        refundApplyData: [],
        tabName: '收入',
        pageTotal: 0,
        applyPageTotal: 0,
        json_fields: { //如果命名的标题有空格,需要用双引号
          门店: "store_type_name",
          订单编号: "no",
          收款编号: "transaction_id",
          客户名称: "name",
          客户手机号: "phone",
          订单金额: "order_money",
          优惠金额: "yh_money",
          支付金额: "money",
          平台收款: "finally_received_money",
          平台结算: "merchant_settlement_money",
          已退金额: "refund_money",
          收款方式: "pay_type_name",
          余额类型: "balance_store_name",
          订单状态: "status",
          订单类型: "type",
          收款时间: "at",
        },
        json_data: [],
        json_refund_fields: { //如果命名的标题有空格,需要用双引号
          退款编号: "no",
          订单编号: "order_no",
          收款编号: "transaction_id",
          客户名称: "name",
          客户手机号: "phone",
          申请人: "apply_name",
          退款金额: "money",
          退款状态: "status_name",
          收款方式: "pay_type_name",
          申请时间: "at",
        },
        json_refund_data: [],
        json_meta: [
          [
            {
              " key ": " charset ",
              " value ": " utf- 8 "
            }
          ]
        ],
        theDetail: {},
        value2: [],
        typeMap: new Map(),
        areaOptions: [],
        area_store: [],
        props: {
          // checkStrictly: true,
          lazy: true,
          lazyLoad: this.lazyLoad
        },
        moenyVisible: false,
        moneyForm: {
          id: null,
          amount: ''
        },
        surpluseMoney: 0
  
      }
    },
    created() {
      this.getRefundApplyStatus()
      this.getTypeMap()
      this.getRefundApplyData()
    },
    methods: {
      getTypeMap() {
        this.Refund_TYPE.forEach(item => {
          this.typeMap.set(item.value, item.label)
        })
      },
      ForMatHMS(date) {
        return moment(parseInt(date + "000")).format("YYYY-MM-DD HH:mm:ss")
      },
      dateFormatHMS: function (row, column) {
        const date = row[column.property];
        if (date === undefined || date === 0) {
          return "";
        }
        return moment(parseInt(date + "000")).format("YYYY-MM-DD HH:mm:ss")
      },
      async handleRefundDownload() {
        if ((this.value2 != null) && (this.value2.length != 0)) {
          this.apply_query.add_start = moment(this.value2[0]).unix()
          this.apply_query.add_end = moment(this.value2[1]).unix()
        } else if (this.value2 == null) {
          this.apply_query.add_start = null
          this.apply_query.add_end = null
        }
        let start_time = this.apply_query.add_start
        let end_time = this.apply_query.add_end
        // 判断时间是否相差93天
        let isNineThree = (end_time - start_time) < 8035200
        if (start_time != null && end_time != null && isNineThree) {
          this.json_refund_data = []
          this.apply_query.page_size = -1
          await get_refund_list(this.apply_query).then(res => {
            let that = this
            res.data.forEach(item => {
              item.no += '&nbsp;'
              item.order_no += '&nbsp;'
              item.money /= 100
              item.name = item.real_name || item.nickname
              item.pay_type_name = this.typeMap.get(item.type)
              if (item.c_at === 0) {
                item.at = "";
              } else {
                item.at = moment(parseInt(item.c_at + "000")).format("YYYY-MM-DD HH:mm:ss")
              }
              item.status_name = that.applyStatusMap.get(item.status)
              that.json_refund_data.push(item)
            })
            this.apply_query.page_size = 10
          })
        } else if (start_time == null || end_time == null) {
          this.$message.error('请选择开始日期和结束日期，最多可导出3个月的数据')
        } else if (!isNineThree) {
          this.$message.error('只能同时导出最多3个月的数据，请重新选择开始时期和结束时期')
        }
      },
      getStoreOption(id) {
        getStoreOption(id).then(res => {
          this.storeOptions = res
        })
      },
  
      lazyLoad(node, resolve) {
        const { level } = node;
        if (level === 0) {
          this.getAreaOptions()
          let nodes = []
          if (this.areaOptions !== []) {
            setTimeout(() => {
              nodes = this.areaOptions.map(item => ({
                value: item.value,
                label: item.label,
                leaf: level >= 1
              }));
              // 通过调用resolve将子节点数据返回，通知组件数据加载完成
              resolve(nodes);
            }, 500);
          }
        }
        if (level === 1) {
          let nodes = []
          this.getStoreOption(node.value)
          if (this.storeOptions !== []) {
            setTimeout(() => {
              nodes = this.storeOptions.map(item => ({
                value: item.value,
                label: item.label,
                leaf: level >= 1
              }));
              // 通过调用resolve将子节点数据返回，通知组件数据加载完成
              resolve(nodes);
            }, 500);
          }
        }
  
      },
      // 获取地址列表
      getAreaOptions() {
        getAreaOption().then(res => {
          this.areaOptions = res
        })
      },
  
  
      handleApplySearch() {
        this.apply_query.page = 1
        this.getRefundApplyData()
      },
      handleApplyizeChange(val) {
        this.apply_query.page_size = val
        this.getRefundApplyData()
      },
      getRefundApplyStatus() {
        getRefundApplyStatusName().then(res => {
          this.applyStatusOptions = res
          let that = this
          res.forEach(function (item) {
            that.applyStatusMap.set(item.value, item.label)
          })
        })
      },
      getRefundApplyData() {
        if ((this.value2 != null) && (this.value2.length != 0)) {
          this.apply_query.add_start = moment(this.value2[0]).unix()
          this.apply_query.add_end = moment(this.value2[1]).unix()
        } else if (this.value2 == null) {
          this.apply_query.add_start = null
          this.apply_query.add_end = null
        }
  
        get_refund_list(this.apply_query).then(res => {
          this.refundApplyData = res.data
          if (this.apply_query.page === 1) {
            this.applyPageTotal = res.count
          }
        })
      },
      handleRefund(id, result) {
        handleRefund(id, result).then(res => {
          if (res === true) {
            this.$message.success("操作成功")
          }
          this.getRefundApplyData()
        })
      },
      // 分页导航
      handleApplyPageChange(val) {
        this.apply_query.page = val
        this.getRefundApplyData()
      },
  
      //   详情展示
      showDetail(id) {
        let that = this
        getDetail(id).then(res => {
          this.theDetail = res
          that.detailVisible = true
        })
  
      },
      handleMoenyClose() {
        this.moenyVisible = false
      },
      setRefundMoney(row) {
        this.moneyForm.id = row.id
        this.moneyForm.amount = (row.money / 100).toFixed(2)
        this.surpluseMoney = (row.pay_notify.money - row.pay_notify.refund - row.pay_notify.refund_apply + row.money) / 100
        this.moenyVisible = true
      },
      editMoney() {
        if (Number(this.moneyForm.amount) > this.surpluseMoney) {
          ElMessage.error('不得超过可退金额')
        } else {
          this.moneyForm.amount = Number(this.moneyForm.amount) * 100
          editRefundMoney(this.moneyForm).then(res => {
            if (res) {
              this.moenyVisible = false
              this.getRefundApplyData()
            }
          })
        }
      },
    }
  }
  
  </script>
  
  <style scoped>
  .handle-box {
    margin-bottom: 10px;
  }
  
  .el-input {
    width: 250px;
    display: inline-block;
    margin-right: 5px;
  
  }
  
  .el-select {
    width: 250px;
    margin-right: 10px;
    margin-bottom: 15px;
  }
  
  .table {
    width: 100%;
    font-size: 14px;
  }
  
  .warning {
    color: #e6a23c;
  }
  
  .export-excel-wrapper {
    margin-left: 10px;
  }
  
  .order-field {
    color: blue;
  }
  
  .el-row {
    margin-bottom: 10px;
  }
  
  .el-col {
    border-radius: 4px;
  
  }
  
  .bg-purple-dark {
    background: #99a9bf;
  }
  
  .bg-purple-light {
    background: #f9f9fc;
  }
  
  .grid-content {
    border-radius: 4px;
    min-height: 24px;
    text-align: center;
    line-height: 24px;
  }
  
  .row-bg {
    padding: 5px 0;
    background-color: #f9fafc;
  }
  
  .el-dialog__body div {
    margin: 0 auto;
    margin-bottom: 5px;
  }
  
  .el-col span {
    margin-right: 30px;
  }
  
  /deep/.el-tabs__item {
    width: 100px;
    text-align: center;
  }
  
  /deep/.el-cascader {
    margin-right: 5px;
  }
  
  .el-button-problem {
    font-size: 20px;
    margin-left: 10px;
    margin-top: 15px;
  }
  </style>
  